"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _registerCSSInterfaceWithDefaultTheme = _interopRequireDefault(require("./utils/registerCSSInterfaceWithDefaultTheme"));

(0, _registerCSSInterfaceWithDefaultTheme["default"])();


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dates/lib/initialize.js
// module id = 1552
// module chunks = 0